import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "../auth/AdminAuthContext";
import { useEmployerAuth } from "../auth/EmployerAuthContext";

export default function EmployerGoogleCallbackPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setEmployer } = useEmployerAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      setError("Google sign-in session was not found.");
      return;
    }
    apiRequest("/employer-auth/google-session", { method: "POST", body: JSON.stringify({ session_id: sessionId }) })
      .then((employer) => {
        setEmployer(employer);
        navigate("/employer/dashboard", { replace: true });
      })
      .catch((requestError) => setError(requestError.message));
  }, [location.hash, navigate, setEmployer]);

  return <main className="access-page" data-testid="employer-google-callback-page"><section className="access-card">{error ? <><h2>Google sign-in could not continue</h2><p className="form-error">{error}</p></> : <><h2>Signing you in with Google…</h2><p>Preparing your employer workspace.</p></>}</section></main>;
}